
export interface ILanguageVariableFilterRequest{
    variable: string,
    languageMissing: number
}
